<div class="unauthorized-container">
  <div class="row">
    <div class="col-12 text-center">
      <p class="py-2"><img [src]="errorhandlerData?.iconPath" alt="icon image for respective message" aria-label="Icon" /></p>
      <h1 class="font-size-32 py-3 fw-bold">{{ errorhandlerData?.title }}</h1>
      <p class="font-size-16 mx-auto" [innerHTML]="errorhandlerData?.description"></p>
    </div>
  </div>
</div>
